import { flashWarningMessage, removeFlashMessageByText } from '~/FlashMessage';
import { handleError } from '.';
import { SlowSaveMessage } from '~/GroupProduct';

import type AuthenticatedApiClient from '~/ApiClient/AuthenticatedApiClient';
import type { Store } from '~/Store';

export default class ErrorHandlerManager {
	constructor(
		private readonly dispatch: Store['dispatch'],
		private readonly authenticatedApiClient: AuthenticatedApiClient
	) {}

	start() {
		this.authenticatedApiClient.addErrorListener((error) => {
			this.dispatch(handleError(error));
		});

		this.authenticatedApiClient.addTimeoutListener((promise) => {
			this.dispatch(flashWarningMessage(SlowSaveMessage, false));
			promise.then(() => {
				this.dispatch(removeFlashMessageByText(SlowSaveMessage));
			});
		});
	}

	destroy() {
		this.authenticatedApiClient.destroy();
	}
}
